import * as actions from "store/actions/bankBillet/edit";
import IUser from "Types/BankBillet";
import dayjs from "dayjs";

export interface BankBilletEditState extends IUser {
	loading: boolean;
	errors: any;
}

const initialState: BankBilletEditState = {
	loading: false,
	value: "",
	dueDate: dayjs().add(3, "day").format("DD/MM/YYYY"),
	description: "",
	document: "",
	name: "",
	email: "",
	status: 0,
	street: "",
	number: "",
	complement: "",
	neighborhood: "",
	city: "",
	state: "",
	country: "",
	zipCode: "",
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.GET_MEI: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_MEI_SUCCESS: {
			return {
				...initialState,
				...payload,
				item: payload
			};
		}
		case actions.GET_MEI_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.EDIT_MEI: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.EDIT_MEI_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.EDIT_MEI_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
